import * as actionTypes from '../../Action/actionTypes';

export const addBranch =(data)=>{
  return {
    type: actionTypes.ADD_BRANCH,
    value: data
  }
};

export const addDepartment=(data)=>{
  return {
    type: actionTypes.ADD_DEPARTMENT,
    value: data
  }
};
export const addWifi=(data)=>{
  return {
    type: actionTypes.ADD_WIFIPACKAGE,
    value: data
  }
};
export const addTagsDashboard = (data) => {
  return {
    type: actionTypes.ADD_TAGS_DASHBOARD,
    value: data
  }
};
export const addTagsDashboardSingle = (type,value) => {
  return {
    type: actionTypes.ADD_TAGS_DASHBOARD_SINGLE,
    value: {
      type: type,
      data: value
    }
  }
};
